var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"position":"relative"}},[_c('dv-scroll-ranking-board',{staticStyle:{"width":"98%","height":"300px","color":"black"},attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }